export const isIframe = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('iframe')) {
    return true;
  }
  return false;
};
